import React, { createContext, useState, useContext, useEffect, ReactNode } from 'react';
import { cookieService, userService } from '../../_services';
import { STRING_CONSTANTS } from '../../utils/constants/stringConstants';

const AffiliateAuthContext = createContext({ isAffiliate: null, isLoading: true });
export const useAffiliateAuth = () => useContext(AffiliateAuthContext);

export const AffiliateAuthProvider = ({ children }: { children: ReactNode }) => {
    const [isAffiliate, setIsAffiliate] = useState<boolean | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const checkStatus = async () => {
            const currentUser = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.user);
            if (!currentUser?.user?.email) {
                setIsAffiliate(false);
                setIsLoading(false);
                return;
            }

            try {
                const response = await userService.aiRequest({
                    method: 'check-whitelabel-affiliate-status',
                    data: { email: currentUser.user.email, whitelabel_domain: window.location.hostname }
                }, true);
                setIsAffiliate(response.data.isAffiliate);
            } catch (error) {
                setIsAffiliate(false);
            } finally {
                setIsLoading(false);
            }
        };
        checkStatus();
    }, []);

    return (
        <AffiliateAuthContext.Provider value={{ isAffiliate, isLoading }}>
            {children}
        </AffiliateAuthContext.Provider>
    );
};
